<script lang="ts">
import Button from '@/components/core/Button.svelte'
import Drawer from '@/components/drawer/Drawer.svelte'
import DrawerActions from '@/components/drawer/DrawerActions.svelte'
import DrawerContent from '@/components/drawer/DrawerContent.svelte'
import DrawerContentText from '@/components/drawer/DrawerContentText.svelte'
import DrawerHeader from '@/components/drawer/DrawerHeader.svelte'
import { testIds } from '@/constants'
import { isDisconnected } from '@/modules/app/connectionStatus'
import { closeDrawer } from '@/modules/drawers'
import { t } from '@/modules/translations'

import TicketForm from './TicketForm.svelte'

const formId = 'ticket-form'
let isSubmitting = $state(false)

const { ticketFormDrawer, ticketFormSubmitButton } = testIds
</script>

<Drawer onClose={closeDrawer} testId={ticketFormDrawer}>
	<DrawerHeader title={$t('ticketForm.submit.button')} />
	<DrawerContent>
		<DrawerContentText class="mb-4">
			{$t('authForm.description')}
		</DrawerContentText>
		<TicketForm bind:isSubmitting id={formId} />
	</DrawerContent>
	<DrawerActions>
		<Button
			type="submit"
			form={formId}
			disabled={$isDisconnected}
			isLoading={isSubmitting}
			isBlock
			testId={ticketFormSubmitButton}>{$t('authForm.button.send')}</Button
		>
	</DrawerActions>
</Drawer>
